import React, { useState, useEffect } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    ListItemText,
    Input
} from "@mui/material";
// import Autocomplete, {
//     createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
// import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import DeleteIcon from "@mui/icons-material/Delete";
import success from "../../assets/img/success.png";
import BackButton from "../../components/BackButton/BackButton";
import failed from "../../assets/img/failed.png";
// import SearchIcon from "@mui/icons-material/Search";
import SearchIcon from "@mui/icons-material/Search";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from 'antd';
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { adminGetCountryList } from '../../redux/actions/adminGetCountryList';
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { AdmingetAdminBankLists } from '../../redux/actions/adminGetBankNameListAction';
import { AdminGetMappingBankLists } from '../../redux/actions/adminGetMappingBankListAction';
import { getMappingBankAdmin } from '../../redux/actions/adminGetMappingBankAction';
import { deleteBankMappingAdmin } from "../../redux/actions/adminDeleteBankMappingAction";
import { AdminGetMappingBankCompareLists } from "../../redux/actions/adminGetMappingBankListCompareAction"
// import { CheckBoxRounded } from '@mui/icons-material';
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminMappingBank = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [countryList, setcountryList] = useState([])
    const [selectedCountry, setselectedCountry] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [walletOwnerIdResp, setwalletOwnerIdResp] = useState([]);
    const [GetwalletOwnerIdResponse, setGetwalletOwnerIdResponse] = useState([]);
    const [walletOwnerID, setwalletOwnerID] = useState('');
    const [GetWalletOwnerID, setGetWalletOwnerID] = useState('');
    const [getBankName, setGetBankName] = useState([])
    const [checkListNotification, setCheckListNotification] = useState(false)
    const [getCountryNameListStatus, setGetCountryNameListStatus] = useState(false);
    const [getCountryListArray, setGetCountryNameListArray] = useState([]);
    const [getBankNameListStatus, setGetBankNameListStatus] = useState(false);
    const [getBankNameListArray, setGetBankNameListArray] = useState([]);
    const [getMappingBankListStatus, setGetMappingBankListStatus] = useState(false);
    const [getMappingBankListStatusArray, setGetMappingBankListStatusArray] = useState("");
    const [mapBankStatus, setMapBankStatus] =
        useState(false);
    const [mapBankStatusResArray, setMapBankStatusResArray] =
        useState("");
    const [deleteBankStatus, setDeleteBankStatus] = useState(false)
    const [deleteBankArray, setDeleteBankArray] = useState("")
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [code, setCode] = useState("");
    const [deleteNotification, setDeleteNotification] = useState(false)
    const [selectedBanks, setSelectedBanks] = useState([]);

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const getWalletOwnerIdRes = useSelector(({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList);
    const GetWalletOwnerIdResPonse = useSelector(({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList);
    const getCountryListRes = useSelector(({ getCountryList }) => getCountryList);
    const getBankNameListRes = useSelector(({ adminGetBanksNameLists }) => adminGetBanksNameLists)
    const getMappingBankListRes = useSelector(({ adminGetMappingBanksLists }) => adminGetMappingBanksLists)
    const getMappingBankRes = useSelector(({ adminGetMappingsBanks }) => adminGetMappingsBanks);
    const deleteBankMappingRes = useSelector(({ adminDeleteBanksLists }) => adminDeleteBanksLists);
    const getMappingBankListCompareRes = useSelector(({ adminGetMappingBankListComparesData }) => adminGetMappingBankListComparesData)
    var authToken = regenerateTokenRes.data.AuthToken;

    const dispatch = useDispatch();
    const classes = useStyles();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleClose = () => {
        setDeleteOpen(false)
    }
    const handleNoticationClose = () => {
        setDeleteNotification(false);

        setCheckListNotification(false)
    };

    const getWalletOwnerIdReq = () => {
        const req = {

            loginDetails: {
                // adminId: regenerateTokenRes.data.partnerId
                adminId: val.adminIDS

            }
        }
        dispatch(getWalletOwnerIdAndNameList(req, authToken));
    };

    useEffect(() => {
        // if (regenerateTokenRes.data.status == "success") {
        getWalletOwnerIdReq();
        // }
    }, []);



    useEffect(() => {
        if (getWalletOwnerIdRes.data.status === 'success') {
            setwalletOwnerIdResp(getWalletOwnerIdRes.data.ownerList);
        }
        if (getWalletOwnerIdRes.data.status === 'failed') {
            if (
                getWalletOwnerIdRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getWalletOwnerIdRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [getWalletOwnerIdRes.data.status])

    // ------Search
    const getWalletOwnerIdRequest = () => {
        const req = {

            loginDetails: {
                // adminId: regenerateTokenRes.data.partnerId
                adminId: val.adminIDS

            }
        }
        dispatch(getWalletOwnerIdAndNameList(req, authToken));
    };

    useEffect(() => {
        // if (regenerateTokenRes.data.status == "success") {
        getWalletOwnerIdRequest();
        // }
    }, []);



    useEffect(() => {
        if (GetWalletOwnerIdResPonse.data.status === 'success') {
            setGetwalletOwnerIdResponse(GetWalletOwnerIdResPonse.data.ownerList);
        }
        if (GetWalletOwnerIdResPonse.data.status === 'failed') {
            if (
                GetWalletOwnerIdResPonse.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                GetWalletOwnerIdResPonse.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [GetWalletOwnerIdResPonse.data.status])

    const getCountryListListReq = () => {
        setGetCountryNameListStatus(true)
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                country: "",
                countryCode: "",
                countryIso: ""
            }
        }
        dispatch(adminGetCountryList(req, authToken));
    };

    const getCountryListFunc = () => {
        if (getCountryNameListStatus) {
            if (getCountryListRes.data.status == "success") {
                setGetCountryNameListArray(getCountryListRes.data.customerMasterDetailsRequestVOList);
            }
            if (getCountryListRes.data.status == "failed") {
                setGetCountryNameListArray(getCountryListRes.data);
                if (
                    getCountryListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getCountryListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getCountryListFunc();
    }, [getCountryListRes.data.status]);

    useEffect(() => {
        getCountryListListReq()
    }, [])





    const handleChange = ({ target: { name, value } }) => {

        if (name === "countryList") {
            setselectedCountry(value === "Select Country" ? "" : value);
            // console.log('Selected Country: ', value);
        }
        // if (name === 'countries') {
        //     setcountries(value);
        // }
        if (name === 'walletOwnerID') {
            setwalletOwnerID(value)
        }
        // if (name === "getBankName") {
        //     // setBankName(value)
        //     setGetBankName(value == "Select Bank" ? "" : value);

        // }
        // if (name === "selectedBanks") {
        //     // setBankName(value)
        //     // setSelectedBanks(value == "Select Bank" ? "" : value);


        // }
        // transferTypes.length === transferTypeList.filter((ch) => !ch.disabled).length
        //                 ? []
        //                 : transferTypeList.filter((ch) => !ch.disabled).map((x) => x.name
        // if (name === 'selectedBanks') {
        //     if (value.includes('all')) {
        //         setSelectedBanks(selectedBanks.length === getBankNameListArray.filter((dd) => !dd.disabled).length
        //             ? []
        //             : getBankNameListArray.filter((dd) => !dd.disabled).map((c) => c.bankName)
        //         )
        //     } else {
        //         setSelectedBanks(value);
        //     }
        // }
        if (name === "selectedBanks") {
            setSelectedBanks(prevSelectedBanks => {
                if (value.includes('all')) {
                    return prevSelectedBanks.length === getBankNameListArray.filter((dd) => !dd.disabled).length
                        ? []
                        : getBankNameListArray.filter((dd) => !dd.disabled).map((c) => c.bankName);
                } else {
                    return value;
                }
            });
        }

        if (name === 'GetWalletOwnerID') {
            setGetWalletOwnerID(value)
        }
    };


    const getBankNameListReq = () => {
        setGetBankNameListStatus(true)
        const Request = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                country: selectedCountry
            }
        }
        dispatch(AdmingetAdminBankLists(Request, authToken));

    }

    const getBankNameListFunc = () => {
        if (getBankNameListStatus) {
            if (getBankNameListRes.data.status == "success") {
                setGetBankNameListArray(getBankNameListRes.data.customerMasterDetailsRequestVOList);
                console.log("getttttBBB", getBankNameListRes)
                testCountryList(selectedCountry, getBankNameListRes.data.customerMasterDetailsRequestVOList);



            }
            if (getBankNameListRes.data.status == "failed") {
                setGetBankNameListArray(getBankNameListRes.data);
                if (
                    getBankNameListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getBankNameListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        if (selectedCountry) {
            getBankNameListReq()
            // setGetBankNameListArray()
            // getBankNameListFunc()
            // testCountryList(selectedCountry)
            // adminGetMappingBankListRequest()


        }
    }, [selectedCountry])

    useEffect(() => {
        getBankNameListFunc()
    }, [getBankNameListRes.data.status])


    useEffect(() => {
        setSelectedBanks('')
    }, [selectedCountry])

    useEffect(() => {
        setselectedCountry('')
        setSelectedBanks('')
    }, [walletOwnerID])



    const adminGetMappingBankListReq = () => {
        setIsLoading(true);
        setGetMappingBankListStatus(true);

        let searchReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: ""
                // walletOwnerId: regenerateTokenRes.data.partnerId,

            }
        }
        dispatch(AdminGetMappingBankLists(searchReq, authToken));

    }

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            adminGetMappingBankListReq();
        }
    }, []);

    const adminGetMappingBankFunc = () => {
        if (getMappingBankListStatus) {
            if (getMappingBankListRes.data.status == "success") {
                setGetMappingBankListStatusArray([].concat(getMappingBankListRes.data.customerMasterDetailsRequestVOList));
                setIsLoading(false);

            }
            if (getMappingBankListRes.data.status == "failed") {
                setGetMappingBankListStatusArray(getMappingBankListRes.data);
                setIsLoading(false);
                if (
                    getMappingBankListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getMappingBankListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getMappingBankListRes.data.status == "NOT FOUND") {
                setGetMappingBankListStatusArray(getMappingBankListRes.data)
                setIsLoading(false)
            }
        }
    }
    useEffect(() => {
        adminGetMappingBankFunc();
    }, [getMappingBankListRes.data.status]);
    const adminGetMappingBankListCompareRequest = (walletOwnerID) => {
        // setIsLoading(true);
        // setGetMappingBankListStatus(true);

        let searchReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: walletOwnerID
            }
        }
        dispatch(AdminGetMappingBankCompareLists(searchReq, authToken));

    }

    const adminGetMappingBankListRequest = () => {
        setIsLoading(true);
        setGetMappingBankListStatus(true);

        let searchReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: GetWalletOwnerID
            }
        }
        dispatch(AdminGetMappingBankLists(searchReq, authToken));

    }

    const getMappingBankListAdminFunc = () => {
        if (getMappingBankListStatus) {
            if (getMappingBankListRes.data.status == "success") {
                setGetMappingBankListStatusArray([].concat(getMappingBankListRes.data.customerMasterDetailsRequestVOList));
                // testCountryList(selectedCountry, getMappingBankListRes.data.customerMasterDetailsRequestVOList);

                setIsLoading(false);

            }
            if (getMappingBankListRes.data.status == "failed") {
                setGetMappingBankListStatusArray(getMappingBankListRes.data);
                setIsLoading(false);
                if (
                    getMappingBankListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getMappingBankListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getMappingBankListRes.data.status == "NOT FOUND") {
                setGetMappingBankListStatusArray(getMappingBankListRes.data)
                setIsLoading(false)
            }
        }
    }

    useEffect(() => {
        getMappingBankListAdminFunc();
    }, [getMappingBankListRes.data.status]);

    const getMappingBankReq = () => {

        const getIda = (ma, ar) => {
            // console.log("main", ar)
            let fa = [];
            const bn = [].concat(ma).map(x => x.bankName);
            for (let i = 0; i < ar.length; i++) {
                fa.push([].concat(ma)[bn.indexOf(ar[i])].id)
            }
            return fa
        }

        setMapBankStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: walletOwnerID,
                // adminId: regenerateTokenRes.data.partnerId,
                adminId: val.adminIDS,
                mappingIdList: getIda(getBankNameListArray, selectedBanks).length == 0 ? '' : getIda(getBankNameListArray, selectedBanks)
            }
        }
        dispatch(getMappingBankAdmin(req, authToken));
    }
    // const handleSelectAll = (event) => {
    //     if (event.target.checked) {
    //         const allBankNames = getBankNameListArray.map((x) => x.bankName);
    //         setSelectedBanks(allBankNames);
    //     } else {
    //         setSelectedBanks([]);
    //     }
    // };

    // const handleBankCheckboxChange = (event, bankName) => {
    //     if (event.target.checked) {
    //         setSelectedBanks((prevSelected) => [...prevSelected, bankName]);
    //     } else {
    //         setSelectedBanks((prevSelected) =>
    //             prevSelected.filter((name) => name !== bankName)
    //         );
    //     }
    // };

    const checkBankNameFunc = () => {
        if (mapBankStatus) {
            if (getMappingBankRes.data.status == "success") {
                setMapBankStatusResArray(getMappingBankRes.data)
                setCheckListNotification(true)
                adminGetMappingBankListReq();
            }
            if (getMappingBankRes.data.status == "failed") {
                setMapBankStatusResArray(getMappingBankRes.data)
                setCheckListNotification(true)
                if (
                    getMappingBankRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getMappingBankRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        checkBankNameFunc()
    }, [getMappingBankRes.data.status])

    const deleteUserFunc = (code) => {

        setCode(code)
        setDeleteOpen(true);
    };
    const deleteBankMappingReq = () => {
        setDeleteBankStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {

                walletOwnerId: regenerateTokenRes.data.partnerId,
                mappingId: code
            }
        }
        dispatch(deleteBankMappingAdmin(req, authToken));
        setDeleteOpen(false)
    }
    const deleteBankMappingFunc = () => {
        if (deleteBankStatus) {
            if (deleteBankMappingRes.data.status == "success") {
                setDeleteBankArray(deleteBankMappingRes.data)
                setDeleteNotification(true)
                adminGetMappingBankListRequest()

            }
            if (deleteBankMappingRes.data.status == "failed") {
                setDeleteBankArray(deleteBankMappingRes.data)
                setDeleteNotification(true)
                if (
                    deleteBankMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    deleteBankMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        deleteBankMappingFunc()
    }, [deleteBankMappingRes.data.status])

    function testCountryList(bankMapping, bankNameList) {
        console.log("getMappingBankListStatusArray//////", getMappingBankListCompareRes, bankNameList)
        let compareBanks = getMappingBankListCompareRes.data.customerMasterDetailsRequestVOList ? [].concat(getMappingBankListCompareRes.data.customerMasterDetailsRequestVOList) : []
        console.log("bbbaaaaannnnkkkk", bankNameList)
        const updatedBankNameList = compareBanks.length ? [].concat(bankNameList).map(bankItem => {
            if (compareBanks.length > 0) {
                const index = compareBanks.findIndex(bankMappingItem => bankMappingItem.bankId === bankItem.id);

                if (index > -1)
                    return { ...bankItem, ...{ disabled: true } }
                return { ...bankItem, ...{ disabled: false } }
            }



        }) : bankNameList
        console.log("bbbbankLissssttt", getBankNameListArray)
        setGetBankNameListArray(updatedBankNameList)
        console.log("update", updatedBankNameList)

        return updatedBankNameList;
        // let z = []
        // let d = []
        // z = getMappingBankListStatusArray.filter((x) => x.country == cn);
        // z = getMappingBankListStatusArray.filter((x) => x.country == cn && x.walletOwnerID == wid);

        // const bkName = getMappingBankListStatusArray.id == getBankNameListArray.id
        // console.log("zzzz", z)
        // console.log('bkname', getBankNameListArray)
        // console.log("ttttt", te)

        // console.log(testCountryList(bankMapping, bankNameList));

    }


    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <DialogTitle>Create Mapping Bank</DialogTitle>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Owner ID"
                                fullWidth={true}
                                name="walletOwnerID"
                                value={walletOwnerID || "Select Owner Id"}
                                onChange={(e) => { handleChange(e); adminGetMappingBankListCompareRequest(e.target.value) }}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {walletOwnerIdResp &&
                                    [].concat(walletOwnerIdResp).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>

                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'

                                label="Country"
                                fullWidth={true}
                                name="countryList"
                                value={selectedCountry || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Country
                                </MenuItem>
                                {/* {getCountryListRes &&
                                    [].concat(getCountryListRes).map((x) => (
                                        <MenuItem key={x.id} value={x.countryName}>
                                            {x.countryName}
                                        </MenuItem>
                                    ))} */}
                                {getCountryListRes.success &&
                                    getCountryListRes.data.customerMasterDetailsRequestVOList.map((x) => (
                                        <MenuItem value={x.countryName}>{x.countryName}</MenuItem>
                                    ))}

                            </TextField>
                        </Grid>

                        {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Bank Name"
                                fullWidth={true}
                                name="BankName"
                                value={bankName || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Bank"
                                    selected="Select Bank"
                                >
                                    Select bank
                                </MenuItem>
                                {getBankNameListRes.success &&
                                    [].concat(getBankNameListRes.data.customerMasterDetailsRequestVOList).map((x) => (
                                        <MenuItem value={x.bankName}>{x.bankName}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={4} lg={4}>

                            <FormControl className={classes.formControl} style={{ width: '100%', marginTop: '-4px' }}>
                                <InputLabel id='multipleCountrySelect'>Select Bank Name</InputLabel>
                                <Select
                                    labelId='multipleCountrySelect'
                                    multiple
                                    fullWidth={true}
                                    variant='standard'

                                    value={selectedBanks || []}
                                    input={<Input />}
                                    renderValue={selected => selected.join(', ')}
                                    onChange={handleChange}
                                    name='selectedBanks'
                                // checked={!getBankNameListArray.some((x) => x?.isChecked !== true)}
                                >

                                    {/* <MenuItem>

                                        <Checkbox></Checkbox>
                                        <ListItemText primary={"Select All"} />
                                    </MenuItem> */}
                                    {/* <MenuItem>
                                        <Checkbox
                                            color='primary'
                                            checked={selectedBanks.length === getBankNameListArray.length}
                                            indeterminate={
                                                selectedBanks.length > 0 && selectedBanks.length < getBankNameListArray.length
                                            }
                                            onChange={handleSelectAll}
                                        />
                                        <ListItemText primary="Select All" />
                                    </MenuItem> */}
                                    <MenuItem key='all' value='all' style={{}}>

                                        {console.log("getBankNameListArray111", getBankNameListArray)}
                                        <Checkbox color='primary' checked={getBankNameListArray.length && selectedBanks.length === getBankNameListArray.filter((ff) => !ff.disabled).length} />
                                        {/* {console.log("fffgggg", ds)} */}
                                        {/* transferTypes.length === transferTypeList.filter((ch) => !ch.disabled).length */}
                                        <ListItemText primary='Select All' />
                                    </MenuItem>
                                    {
                                        getBankNameListArray && [].concat(getBankNameListArray).map((x, index) => {
                                            return (
                                                // <MenuItem key={index} value={`${x.bankName}`}>
                                                //     <Checkbox color='primary' checked={getBankName.indexOf(`${x.bankName}`) > -1} />
                                                //     <ListItemText primary={x.bankName} />
                                                // </MenuItem>
                                                // <MenuItem key={index} value={x.id}>
                                                //     <Checkbox color='primary' checked={getBankName.indexOf(x.bankName) > -1} />
                                                //     <ListItemText primary={x.bankName} />
                                                // </MenuItem>
                                                // <MenuItem key={index} value={`${x.bankName}`}>

                                                //     <Checkbox color='primary' checked={getBankName.indexOf(`${x.bankName}`) > -1} />
                                                //     <ListItemText primary={x.bankName} />
                                                // </MenuItem>

                                                // <MenuItem key={index} value={`${x.bankName}`}>
                                                //     <Checkbox
                                                //         color='primary'
                                                //         checked={selectedBanks.indexOf(`${x.bankName}`) > -1}
                                                //         onChange={(event) => handleBankCheckboxChange(event, x.bankName)}
                                                //     />
                                                //     <ListItemText primary={x.bankName} />
                                                // </MenuItem>

                                                <MenuItem
                                                    key={index}
                                                    value={`${x.bankName}`}
                                                    className='bankNameColor'
                                                    disabled={x.disabled}
                                                // style={{ color: x.disabled ? 'red' : 'green' }}
                                                >
                                                    <Checkbox color='primary' checked={selectedBanks.indexOf(`${x.bankName}`) > -1} />
                                                    <ListItemText primary={x.bankName} />
                                                </MenuItem>


                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={getMappingBankReq}
                            >
                                Create

                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                <Card>
                    <DialogTitle>Search</DialogTitle>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Owner ID"
                                variant='standard'
                                fullWidth={true}
                                name="GetWalletOwnerID"
                                value={GetWalletOwnerID || "Select Owner Id"}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {GetwalletOwnerIdResponse &&
                                    [].concat(GetwalletOwnerIdResponse).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>

                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={adminGetMappingBankListRequest}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getMappingBankListStatusArray.length == undefined ||
                    !getMappingBankListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"

                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank ID{" "}

                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Wallet Owner Name{" "}

                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Country
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>




                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getMappingBankListStatusArray &&
                                                []
                                                    .concat(getMappingBankListStatusArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.bankId}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.walletOwnerName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.bankName}
                                                            </TableCell>
                                                            <TableCell align="center">{row.country}</TableCell>

                                                            <TableCell align="center">
                                                                <Tooltip title="Delete">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px",
                                                                            // margin: "0 8px"

                                                                        }}
                                                                        onClick={() =>
                                                                            deleteUserFunc(row.bankId)
                                                                        }
                                                                    >
                                                                        {
                                                                            <DeleteIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                            </TableCell>




                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getMappingBankListStatusArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}
            </Layout>
            <div>
                <Dialog open={deleteOpen} onClose={handleClose}>
                    <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                    <DialogActions className="p-3">
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                padding: "8px"
                            }}
                            // variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px",
                                width: "60px"
                            }}
                            onClick={deleteBankMappingReq}

                        >
                            Yes
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            {getMappingBankRes.data.status == "success" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapBankStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getMappingBankRes.data.status == "failed" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapBankStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {deleteBankMappingRes.data.status == "success" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteBankArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


            {deleteBankMappingRes.data.status == "failed" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteBankArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminMappingBank